<template>
    <div

        :class="['post', {
            highlight: post.highlight
        }]"
    >
        <div class="content">
            <h4 v-html="post.name"></h4>
            <div class="baseline" v-html="post.baseline"></div>
        </div>
        <router-link
            v-if="post.layout && post.layout.length > 0"
            :to="$trl({
                name: 'Method',
                params: {
                    slug: post.customslug || post.slug,
                    locale: $route.params.locale,
                    technique
                }
            })"
        >
            <IconPlus/> {{$t('cta.showmore')}}
        </router-link>
        <a @click="openPopin(post)" v-else-if="post.image || post.description || post.pictogram">
            <IconPlus/> {{$t('cta.showmore')}}
        </a>
    </div>
</template>
<script>
import IconPlus from '@/components/IconPlus'
import {popin} from '@/store/index.js'
export default {
    components: {
        IconPlus
    },
    props: {
        post: {
            type: Object,
            default() {}
        }
    },
    computed: {
        related() {
            const res = (this.$parent.$parent.page.type === 'project') ?
                this.$parent.$parent.page.related_posts
                    .filter(item => {
                        return this.post.related_posts.find(_ => _ === item.id)
                    }) : [{ name: this.$parent.$parent.page.name }]
            return res
        },
        technique() {
            return this.$parent.$parent.page.customslug || this.$parent.$parent.page.slug
        }
    },
    methods: {
        openPopin(post) {
            popin.data = post
            popin.state = true
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.post
    width: 33.33%
    display: block
    // border-bottom: 1px solid #e0e1e3
    // border-left: 1px solid #e0e1e3
    position: relative
    height: 39.0625em
    padding-top: 5%
    padding-left: 3.5%
    padding-right: 3.5%
    display: inline-flex
    flex-direction: column
    border: 1px solid #e0e1e3
    width: 506px
    .method &
        @include media-breakpoint-up($md)
            margin-left: -1px
            &:nth-child(2n+1)
                margin-left: 0
            &:nth-child(n+3)
                margin-top: -1px
        @include media-breakpoint-up(1725px)
            margin-left: -1px
            &:nth-child(2n+1)
                margin-left: -1px
            &:nth-child(n+3)
                margin-top: 0
            &:nth-child(3n+1)
                margin-left: 0
            &:nth-child(n+4)
                margin-top: -1px
        @include media-breakpoint-down($hd)
            margin-left: 0
            &:nth-child(2n+1)
                margin-left: 0px
            &:nth-child(n+3)
                margin-top: 0
            &:nth-child(3n+1)
                margin-left: 0
            &:nth-child(n+4)
                margin-top: 0px
    @include media-breakpoint-down($hd)
        width: 50%
        // border-top: 1px solid #e0e1e3
    @include media-breakpoint-down($lg)
        padding-top: 14%
        padding-left: 9.5%
        padding-right: 9.5%
        width: 100%
        height: 82.6666666667vw
    @include media-breakpoint-down($sm)
        height: auto
        padding-bottom: 14%
    @media print
        height: auto
        padding-top: 0
        padding-bottom: 0
        margin-top: .6cm
        margin-bottom: .6cm
        border: none
        padding-left: 0
        padding-right: 0
    &.highlight
        height: auto
        width: auto
        margin-bottom: 7%
        padding-left: 10px
        padding-top: 4.875%
        padding-left: 10%
        padding-bottom: 8%
        width: 100%
        @include media-breakpoint-down($sm)
            padding-top: 14%
            padding-bottom: 14%
        @media print
            height: auto
            padding-top: 0
            padding-bottom: 0
            margin-top: .6cm
            margin-bottom: .6cm
            border: none
            padding-left: 0
            padding-right: 0

        &:before
            content: ""
            display: block
            position: absolute
            top: 0px
            bottom: 0px
            left: 0px
            width: 10px
            background-color: #ff2b2a
            @media print
                display: none
.content
    flex: 1
h4
    font-size: 50px
    line-height: 1
    color: #ff2b2a
    font-weight: 500
    height: 3em
    display: -webkit-box
    -webkit-line-clamp: 3
    -webkit-box-orient: vertical

    @include media-breakpoint-down($hd)
        // font-size: 32px
    @include media-breakpoint-down($sm)
        font-size: 25px
        height: auto
    @media print
        font-size: 25px
        height: auto
        margin-bottom: .3cm
        padding-left: 0
        padding-right: 0
    .highlight &
        height: auto
        font-size: 86px
        @include media-breakpoint-down($lg)
            font-size: 50px
        @include media-breakpoint-down($sm)
            font-size: 25px
        @media print
            font-size: 25px
            height: auto
            margin-bottom: .6cm
            padding-left: 0
            padding-right: 0

.baseline
    font-size: 28px
    color: #636772
    line-height: 1.4285714286
    margin-top: 5.25%
    display: -webkit-box
    -webkit-line-clamp: 6
    -webkit-box-orient: vertical
    overflow: hidden
    height: 1.4285714286 * 6em
    letter-spacing: -0.015em
    width: 100%;
    /deep/ p
        font-size: inherit
        line-height: inherit
    /deep/ ul
        padding-left: 1.2em
        list-style: disc
        li
            font-size: inherit
            line-height: inherit
    @include media-breakpoint-down($lg)
        height: 1.4285714286 * 4em
        -webkit-line-clamp: 4
        font-size: 26px
    @include media-breakpoint-down($sm)
        height: auto
        -webkit-line-clamp: none
        font-size: 17px
    .highlight &
        display: block
        height: auto
        margin-top: 3.625%
        // column-count: 2
        // column-gap: 80px
        padding-right: 24%
        @include media-breakpoint-down($hd)
            padding-right: 12%
        @include media-breakpoint-down($lg)
            padding-right: 0
            // column-count: 1
            // column-gap: 0px

a
    text-decoration: none
    font-weight: 500
    font-size: 20px
    color: #636776
    display: flex
    align-items: center
    margin-bottom: 1.5em
    padding-top: 1.2em
    padding-bottom: 1.2em
    cursor: pointer
    @include media-breakpoint-down($lg)
        font-size: 17px
    @include media-breakpoint-down($sm)
        padding-bottom: 0
        margin-bottom: 0
    @media print
        display: none
    .highlight &
        margin-bottom: -5%
        margin-top: 6%
    svg
        width: 1.45em
        height: 1.45em
        margin-right: 2em
        /deep/ path
            fill: #ff2b2a

</style>
